module.exports = __webpack_public_path__ + "static/cercamappa_milano-3e45e460364b0f5b42382904d422054b.jpg";